import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, map } from 'rxjs';
import { User, UserDto, UserDtoMapper } from 'src/app/shared/dtos/user.dto';
import { State } from '../state/state';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable({ providedIn: 'root' })
export class AuthService {
  readonly http = inject(HttpClient);
  readonly state = inject(State);
  readonly currentUserSubject$ = new BehaviorSubject<User>(
    JSON.parse(localStorage.getItem('currentUser'))
  );
  public userToken$ = new BehaviorSubject<string>(
    localStorage.getItem('token')
  );

  public get currentUserValue() {
    return this.currentUserSubject$.value;
  }

  public get getUserToken() {
    return this.userToken$.value;
  }

  public get isLoggedIn(): boolean {
    return !!this.currentUserSubject$.value;
  }

  login(username: string, password: string) {
    return this.http.post('/users/authenticate', { username, password });
  }

  setToken(token: string) {
    localStorage.setItem('token', token);
    this.userToken$.next(token);
  }

  logout() {
    this.state.loading.next({
      spinner: false,
      message: '',
    });
    localStorage.removeItem('token');
    localStorage.removeItem('currentUser');
    this.currentUserSubject$.next(null);
    this.userToken$.next(null);
  }

  getUser() {
    return this.http
      .get<UserDto>('/user', {
        headers: {
          Authorization: localStorage.getItem('token') || '',
        },
      })
      .pipe(
        map((dto: UserDto) => {
          const user = UserDtoMapper(dto);
          localStorage.setItem('currentUser', JSON.stringify(user));
          this.currentUserSubject$.next(user);
          return user;
        })
      );
  }
}
